import { createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => createStyles({
  order: {
    backgroundColor: '#F9FAFB',
    padding: 10,
    marginTop: 16,
  },
  orderTitle: {
    color: '#2C3D77',
    fontFamily: "'Roboto', 'Bold'",
    fontSize: 16,
    fontWeight: 500,
    marginBottom: 5,
  },
  orderContent: {
    color: '#2E3F5A',
    fontFamily: "'Roboto', 'Regular'",
    fontSize: 14,
  },
  orderPrice: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    color: '#263245',
    fontFamily: "'Roboto', 'Regular'",
    fontSize: 16,
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}));

export default useStyles;
